import styled from 'styled-components';
import {
  blackSphera,
  grayDarkSphera,
  greenSp,
  whiteSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const Eventswebinars = styled.section``;

export const EventsWebinarFigure = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 80%;
  margin: 10% 10% 0 10%;
  > div:nth-child(1),
  div:nth-child(3),
  div:nth-child(5) {
    padding: 1%;
    width: 30%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    > figure {
      margin-top: 3%;
      align-self: center;
      > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    > p {
      width: 100%;
      margin-top: 5%;
      font-size: 1.2vw;
      color: ${blackSphera};
      text-align: center;
      font-weight: bold;
    }
  }
  > div:nth-child(2),
  div:nth-child(4) {
    margin-top: 3%;
    width: 1px;
    height: 115px;
    background-color: #c5d0e5;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1),
    div:nth-child(3),
    div:nth-child(5) {
      > figure {
        width: 100px;
        height: 100px;
        margin-top: 3%;
        align-self: center;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      > p {
        margin-top: 1%;
        font-size: 1.5vw;
      }
    }
  }

  @media (max-width: 600px) {
    margin-top: 2%;
    > div:nth-child(1),
    div:nth-child(3),
    div:nth-child(5) {
      padding: 1%;
      width: 90%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      > figure {
        margin-top: 4%;
      }
      > p {
        font-size: 4vw;
      }
      > div:nth-child(2) {
        height: 90px;
      }
      > figure:nth-child(3) {
        width: 50px;
        height: 50px;
        margin-top: 4%;
        > p {
          margin-top: 15%;
          font-size: 2vw;
        }
      }
    }
    > div:nth-child(2),
    div:nth-child(4) {
      display: none;
    }
  }
`;

export const InflationEventsWebinars = styled.section`
  display: flex;
  flex-wrap: wrap;
  background-color: white;
  margin-bottom: 5%;
  > div {
    width: 50%;
    margin-top: 5%;
    padding-left: 5%;
    > h2 {
      margin-bottom: 2%;
      font-size: 2vw;
    }
    > p {
      margin-bottom: 2%;
      width: 75%;
      font-size: 1.2vw;
    }
  }
  > div:nth-child(2) {
    width: 50%;
    > div {
      width: 80%;
      border-radius: 10px;
      -webkit-box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
      box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
      > h2 {
        color: ${blackSphera};
        text-align: center;
        padding-top: 7%;
        font-size: 1.5vw;
      }
      > p {
        margin-left: 10%;
        font-size: 1.2vw;
        color: ${blackSphera};
      }
      > input {
        border-color: 1px solid ${grayDarkSphera};
        border-radius: 25;
        margin-left: 10%;
        margin-bottom: 5%;
        width: 50%;
        padding: 1% 3%;
      }
      > div:nth-child(6) {
        display: flex;
        justify-content: space-around;
        width: 90%;
        margin: auto auto 5% auto;

        > input {
        }

        > p {
          font-size: 1vw;
          color: ${blackSphera};
          width: 80%;
        }
      }
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(2) {
      width: 50%;
      > div {
        width: 80%;
        border-radius: 10px;
        > h2 {
          font-size: 2vw;
        }
        > p {
          font-size: 1.2vw;
        }
        > input {
          border-color: 1px solid ${grayDarkSphera};
          border-radius: 25;
          margin-left: 10%;
          width: 50%;
          padding: 0;
        }
      }
    }
  }
  @media (max-width: 600px) {
    > div {
      padding: 1% 5%;
    }
    > div:nth-child(1) {
      width: 100%;
      > h2 {
        font-size: 6vw;
        margin-bottom: 2.5%;
      }
      > p {
        font-size: 4.2vw;
        width: 100%;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      > div {
        width: 100%;
        > h2 {
          font-size: 6vw;
          margin-bottom: 5%;
        }
        > p {
          font-size: 4vw;
          margin-bottom: 3%;
        }
        > input {
          margin-bottom: 5%;
          width: 80%;
          padding: 2% 3%;
        }
        > div:nth-child(6) {
          > input {
          }

          > p {
            font-size: 3vw;
          }
        }
      }
    }
  }
`;

export const InflationSignUp = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: auto;
  padding-bottom: 3%;
  margin-top: 2%;
  > button {
    font-size: 0.9vw;
    border: none;
    background-color: ${blackSphera};
    color: white;
    width: 40%;
    height: 35px;
    border-radius: 3px;
  }
  > a {
    display: block;
    text-align: center;
    width: 40%;
    text-decoration: none;
    background-color: white;
    color: ${blackSphera};
    font-size: 0.9vw;
    border: 1px solid ${blackSphera};
    border-radius: 3px;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > button {
      font-size: 1.3vw;
    }
    > a {
      font-size: 1.3vw;
    }
  }
  @media (max-width: 600px) {
    flex-direction: column;
    > button {
      font-size: 4vw;
      width: 100%;
      margin-bottom: 5%;
    }
    > a {
      font-size: 4vw;
      width: 100%;
    }
  }
`;

export const CompoundInterestConstancy = styled.section`
  background-color: ${greenSp};
  padding-bottom: 5%;
  > h2 {
    width: 50%;
    margin: auto;
    padding: 2% 0 1% 0;
    text-align: center;
    font-size: 2.5vw;
    color: ${blackSphera};
  }
  > p {
    text-align: center;
    padding-bottom: 2%;
    font-size: 1.1vw;
    color: ${blackSphera};
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      width: 70%;
      font-size: 3vw;
    }
    > p {
      font-size: 2vw;
    }
  }
  @media (max-width: 600px) {
    padding-bottom: 5%;
    > h2 {
      width: 90%;
      padding: 5% 0 1% 0;
      font-size: 6vw;
    }
    > p {
      font-size: 3vw;
      margin-bottom: 3%;
    }
  }
`;

export const SuperPowerCards = styled.section`
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: auto;
  > div:nth-child(1),
  > div:nth-child(2),
  > div:nth-child(3) {
    width: 25%;
    padding: 3% 0 2.5% 0;
    background-color: ${blackSphera};
    border-radius: 5px;
    > h5 {
      text-align: center;
      font-size: 1.2vw;
      color: white;
    }
    > p {
      width: 75%;
      margin: 7% auto auto auto;
      text-align: center;
      font-size: 1.2vw;
      color: white;
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1),
    > div:nth-child(2),
    > div:nth-child(3) {
      > h5 {
        font-size: 1.5vw;
      }
      > p {
        font-size: 1.3vw;
      }
    }
  }
  @media (max-width: 600px) {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 80%;
    > div:nth-child(1),
    > div:nth-child(2),
    > div:nth-child(3) {
      width: 100%;
      height: 170px;
      margin-bottom: 5%;
      > h5 {
        font-size: 5vw;
      }
      > p {
        width: 80%;
        font-size: 3.2vw;
      }
    }
  }
`;

export const OurSpeakrs = styled.section`
  background-color: white;
  > h2 {
    padding: 2% 0 5% 0;
    text-align: center;
    font-size: 2.5vw;
    color: ${blackSphera};
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      font-size: 3vw;
    }
  }
  @media (max-width: 600px) {
    > h2 {
      padding: 5% 0 5% 0;
      font-size: 6vw;
    }
  }
`;

export const OurSpeakrsCardCont = styled.section`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: auto;
  padding-bottom: 3%;
  @media (min-width: 600px) and (max-width: 1024px) {
  }
  @media (max-width: 600px) {
    flex-direction: column;
    width: 75%;
    padding-bottom: 10%;
  }
`;

export const OurSpeakrsCard = styled.section`
  width: 20%;
  -webkit-box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.2);
  > div:nth-child(1) {
    border: none;
    padding-top: 10%;
    height: 40%;
    padding-bottom: 5%;
    > figure {
      width: 50%;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  > div:nth-child(2) {
    width: 100%;
    height: 60%;
    padding-bottom: 10%;
    padding-top: 10%;
    align-items: space-between;
    > h3 {
      font-size: 1.5vw;
      font-weight: normal;
      text-align: center;
      margin-bottom: 2%;
    }
    > p {
      font-size: 1.2vw;
      text-align: center;
      margin-bottom: 5%;
    }
    > figure:nth-child(3) {
      width: 100px;
      height: auto;
      margin: 2% auto;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    > a {
      > figure {
        width: 50px;
        height: auto;
        margin: auto;
        bottom: 0;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(2) {
      > figure:nth-child(3) {
        width: 80px;
      }
      > a {
        > figure {
          width: 30px;
        }
      }
    }
  }
  @media (max-width: 600px) {
    width: 100%;
    margin-top: 5%;
    > div:nth-child(1) {
      > figure {
      }
    }
    > div:nth-child(2) {
      > h3 {
        font-size: 5vw;
      }
      > p {
        font-size: 3vw;
      }
      > figure:nth-child(3) {
        width: 100px;
      }
      > a {
        > figure {
          width: 50px;
        }
      }
    }
  }
`;

export const OurSponsors = styled.section`
  padding: 5% 0 5% 0;
  > h2 {
    font-size: 2.5vw;
    text-align: center;
    color: ${blackSphera};
    padding-bottom: 5%;
  }
  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 95%;
    gap: 2.5%;
    margin: auto;

    > a {
      > figure {
        background-color: ${whiteSphera};
        > img {
          width: 100%;
          height: 100%;
          /* filter: grayscale(1); */
        }
      }
    }

    > a:nth-child(1) {
      width: 20%;
    }

    > a:nth-child(2) {
      width: 12%;
    }

    > a:nth-child(3) {
      width: 15%;
    }

    > a:nth-child(4) {
      width: 18%;
    }

    > a:nth-child(5) {
      width: 15%;
    }

    > a:nth-child(6) {
      width: 20%;
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      font-size: 3vw;
    }
    > div {
      > a {
        > figure {
          > img {
          }
        }
      }

      > a:nth-child(1) {
      }

      > a:nth-child(2) {
      }

      > a:nth-child(3) {
      }

      > a:nth-child(4) {
      }

      > a:nth-child(5) {
      }

      > a:nth-child(6) {
      }
    }
  }
  @media (max-width: 600px) {
    padding: 3% 0 3% 0;
    > h2 {
      font-size: 6vw;
      padding-bottom: 2%;
    }
    > div {
      > a {
        > figure {
          > img {
          }
        }
      }

      > a:nth-child(1) {
      }

      > a:nth-child(2) {
      }

      > a:nth-child(3) {
      }

      > a:nth-child(4) {
      }

      > a:nth-child(5) {
      }

      > a:nth-child(6) {
      }
    }
  }
`;
